<template>
  <div class="card-single__badges">
    <!-- time left -->
    <AppBadge
      v-if="userType === 'EMPLOYEE' && timeLimit"
      class="time-left"
      :class="timeLimitClass"
      icon="far fa-stopwatch"
    >
      <span v-if="timeLimit.type === 'hours'">{{ timeLimit.time }} h</span>
      <span v-else>{{ timeLimit.time }} m</span>
    </AppBadge>
    <!-- pending tasks -->
    <AppBadge
      v-if="card.pending_tasks"
      :title="$t('card_single.badges.peding_tasks')"
      class="pending-tasks"
      icon="fas fa-check-square"
    />
  </div>
</template>

<script>
// Utilities
import { getTimeLimit } from 'Utils'
import { authComputed } from 'Store/helpers'
// Components
import AppBadge from 'Ui/AppBadge'

export default {
  name: 'CardSingleBadges',

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  components: {
    AppBadge,
  },

  methods: {},

  computed: {
    ...authComputed,
    timeLimit() {
      return getTimeLimit(this.card.timelimit)
    },

    timeLimitClass() {
      let className = ''
      if (this.timeLimit.type === 'minutes' && !this.timeLimit.time) className = 'alert'
      if (this.timeLimit.type === 'minutes' && this.timeLimit.time) className = 'warning'
      if (this.timeLimit.type === 'hours' && this.timeLimit.time < 3) className = 'warning'
      return className
    },
  },
}
</script>

<style scoped>
.card-single__badges {
  display: flex;
}

.card-single__badges span:not(:last-of-type) {
  margin-right: 5px;
}

.badge.pending-tasks {
  min-width: 40px;
  background-color: var(--c-yellow-500);
}

.badge >>> .badge__icon {
  font-size: 15px;
  color: #fff;
}

.badge.time-left.alert >>> span,
.badge.time-left.alert >>> .badge__icon {
  color: #fff;
}

.badge.time-left.alert {
  background-color: var(--c-error);
}

.badge.time-left.warning {
  background-color: var(--c-yellow-500);
}
</style>
